import React from "react";
import style from "css/lecture.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useMediaQuery } from "react-responsive";

function Common(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  return (
    <div className={style.wrapper}>
      <div className={style.commonHeader}>
        <div className={style.CommonHeaderTxt}>
          <p>
            <font>{props.headerInfo.subTitle}</font>
            <font>{props.headerInfo.title}</font>
          </p>
          <p>{props.headerInfo.info.map((info) => info)}</p>
        </div>
        <img
          alt=""
          src={
            !isMobile && !isTablet
              ? `${process.env.REACT_APP_CLIENT_URL}` + props.headerInfo.img
              : `${process.env.REACT_APP_CLIENT_URL}` + props.headerInfo.img_m
          }
        />
      </div>

      <div
        style={
          !isMobile && !isTablet
            ? {
                marginTop: "120px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }
            : {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }
        }
      >
        <div className={style.commonBody}>
          {props.bodyHeader}

          <div className={style.bodyInfoWrap}>
            {!isMobile && !isTablet
              ? props.bodyInfo.map((info) =>
                  info.id % 2 === 1 ? (
                    <div className={style.bodyInfo}>
                      <div className={style.bodyInfoImg}>
                        <img
                          alt=""
                          src={
                            !isMobile && !isTablet
                              ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                              : `${
                                  process.env.REACT_APP_CLIENT_URL + info.img_m
                                }`
                          }
                        />
                      </div>
                      <div className={style.bodyInfoTxt}>
                        <div className={style.bodyInfoTxtBody}>
                          <p>{info.id}</p>
                          <p>{info.title}</p>
                          {info.txt}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={style.bodyInfo}>
                      <div className={style.bodyInfoTxt}>
                        <div className={style.bodyInfoTxtBody}>
                          <p>{info.id}</p>
                          <p>{info.title}</p>
                          {info.txt}
                        </div>
                      </div>
                      <div className={style.bodyInfoImg}>
                        <img
                          alt=""
                          src={
                            !isMobile && !isTablet
                              ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                              : `${
                                  process.env.REACT_APP_CLIENT_URL + info.img_m
                                }`
                          }
                        />
                      </div>
                    </div>
                  )
                )
              : props.bodyInfo.map((info) => (
                  <div className={style.bodyInfo}>
                    <div className={style.bodyInfoImg}>
                      <img
                        alt=""
                        src={
                          !isMobile && !isTablet
                            ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                            : `${process.env.REACT_APP_CLIENT_URL + info.img_m}`
                        }
                      />
                    </div>
                    <div className={style.bodyInfoTxt}>
                      <div className={style.bodyInfoTxtBody}>
                        <p>{info.id}</p>
                        <p>{info.title}</p>
                        {info.txt}
                      </div>
                    </div>
                  </div>
                ))}

            <div className={style.bodyLine} />

            <div className={style.bodyFooter}>
              {props.bodyFooterTitle}
              <div className={style.bodyFooterCardWrap}>
                {props.bodyFooter.map((info) => (
                  <div className={style.bodyFooterCard}>
                    <p>{info.id}</p>
                    {info.title}
                    <p>{info.txt}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {props.composeHeader}

            <Swiper
              scrollbar={{ draggable: true }}
              slidesPerView={"auto"}
              spaceBetween={50}
              modules={[Scrollbar]}
              className={style.commonComposeCardWrap}
              observer={true}
              observeParents={true}
              observeSlideChildren={true}
              grabCursor={true}
            >
              {props.compose.map((info, index) => (
                <SwiperSlide className={style.commonComposeCard} key={index}>
                  <div
                    className={
                      info.link === "/smart-solution/deviceOne"
                        ? `${style.commonComposeCardImg} ${style.platform}`
                        : style.commonComposeCardImg
                    }
                  >
                    <p>
                      <font>{info.id}</font> / {props.compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    {/* <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    > */}
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>
                    {/* </Link> */}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage:
                    "url('" +
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/composefooterImg.png')",
                }}
              >
                <p>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/bang.png"
                    }
                  />
                </p>
                <p>
                  <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                  통해 정확히 진단해 보세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Common;
